import { useCallback, useMemo } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { ArrowIosDownOutline } from '@lyearn/icons';
import { Stack, Typography } from '@lyearn/ui';
import SingleSelectFilter from '@/components/FilterManager/SingleSelectFilter';

import { DateValueTypeEnumSM } from '../types';
import { getDateValueTypeOptions } from '../utils';

type DateValueTypeSelectorProps = {
  dateValueType?: DateValueTypeEnumSM;
  disabled?: boolean;
  onChange: (val: DateValueTypeEnumSM) => void;
};

const OVERRIDES = {
  PopoverContent: {
    minWidth: 32,
  },
};

export default function DateValueTypeSelector(props: DateValueTypeSelectorProps) {
  const { t } = useTranslation();
  const { dateValueType, disabled, onChange } = props;
  const conditions = useMemo(() => getDateValueTypeOptions(t), [t]);
  const selectedCondition = conditions.find((con) => con.id === dateValueType);
  const onConditionChange = useCallback(
    (val: string) => {
      onChange(val as DateValueTypeEnumSM);
    },
    [onChange],
  );

  return (
    <SingleSelectFilter
      defaultSortBy={dateValueType}
      disabled={disabled}
      items={conditions}
      overrides={OVERRIDES}
      onChange={onConditionChange}>
      <Stack
        alignItems="center"
        className="h-40 w-full rounded-8 border border-field pe-12 ps-16"
        gapX={8}
        justifyContent="between">
        <Typography variant="body-short-02">{selectedCondition?.label}</Typography>
        <ArrowIosDownOutline className="h-20 w-20" fillColorToken="icon-secondary" />
      </Stack>
    </SingleSelectFilter>
  );
}
